module.exports = __webpack_public_path__ + "img/start.fca5c812.png";